export const Chip = ({ active, onClick, children, testId, tone = "terracotta" }) => {
  const on = tone === "forest" ? "bg-[#163A2B] border-[#163A2B] text-white" : "bg-[#2F7D55] border-[#2F7D55] text-white";
  return (
    <button type="button" data-testid={testId} onClick={onClick} aria-pressed={!!active}
      className={`px-3.5 py-1.5 rounded-full border text-sm font-semibold transition-colors duration-150 active:scale-95 ${active ? on : "bg-white border-stone-300 text-stone-700 hover:border-stone-500"}`}>
      {children}
    </button>
  );
};

export const FieldLabel = ({ children }) => (
  <p className="text-xs uppercase tracking-wider font-semibold text-stone-500 mb-2">{children}</p>
);

export const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-");
